import React from 'react';
import { ChatBottomBarView } from './view';
import { styles } from './styles';

export class ChatBottomBar extends React.Component {
  render() {
    return <ChatBottomBarView {...this.props} styles={styles} />;
  }
}
